export const SET_CURRENT_VIDEO_POSITION = 'SET_CURRENT_VIDEO_POSITION';

export function setCurrentVideoPosition(id, position) {
    return {
        type: SET_CURRENT_VIDEO_POSITION,
        payload: {
            id,
            position,
        },
    };
}
